// Adapted from https://usehooks.com/useWindowSize/
import { useEffect, useState } from 'react';
import { theme } from '../theme';
export const useWindowProperties = () => {
    const [windowProperties, setWindowProperties] = useState({
        width: undefined,
        height: undefined,
        isMobile: undefined,
        isDesktop: undefined,
        isTablet: undefined,
    });
    const handleResize = () => {
        setWindowProperties({
            width: window.innerWidth,
            height: window.innerHeight,
            isMobile: window.innerWidth < theme.windowSizesPx.sm,
            isDesktop: window.innerWidth >= theme.windowSizesPx.md,
            isTablet: window.innerWidth >= theme.windowSizesPx.sm &&
                window.innerWidth < theme.windowSizesPx.md,
        });
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowProperties;
};
//# sourceMappingURL=useWindowProperties.js.map